// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"888":"7c4c6eb5870f5d114adc","937":"6c5432ac68e4ea6d018b"}[chunkId] + ".css";
};